import React, { Component } from "react";
import { Row, Col, Button, FormGroup, FormControl, ControlLabel, Table, Modal, Label, OverlayTrigger, Tooltip, Glyphicon } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Switch from 'react-bootstrap-switch';

import UsersService from "../../services/users-service";
import FormsService from "../../services/forms-service";
import AssignmentService from "../../services/assignments-service";
import UtilsService from "../../services/utils-service";

import EventWidget from "../../components/widgets/event-widget";


import Widgets from "../../components/widgets";
import {ToastContainer, ToastStore} from 'react-toasts';
import './style.css';
import _ from 'underscore';
import moment from 'moment';

class Assignments extends Component {

    tableData = {
        columns: [
            {
                label: 'Title',
                field: 'title',
                sort: 'asc',
                width: 300
            },
            {
                label: 'Facility',
                field: 'facility',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Date',
                field: 'date',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Time',
                field: 'time',
                sort: 'asc',
                width: 100
            },
        ],
        rows: []
    }

    constructor(props, context) {
        super(props, context);

        const storedCredentials =  UsersService.sharedInstance.getStoredCredentials();
        const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;

        this.state = {
            show: false,
            data: this.tableData,
            token: credentials.token_data.token,
            auth_username: credentials.data[0].User_ID,
            license: credentials.data[0].User_License,
            sub_user_id: credentials.data[0].recno,
            showInfoModal: false,
            showDispatchModal: false,
            dispatchToDisplay: null,
            assignmentToDisplay: null,
            on_duty: storedCredentials.onDuty == 1 ? true : false,
            dispatch_modal: false
        }

        this.start_date = "";
        this.end_date = "";
        const statusIndex = 5;
        this.options = {
            onRowClick: (row, columnIndex) => {
                if(columnIndex != statusIndex){
                    this.openModal(row)
                }
            },
            hideSizePerPage: true,
            defaultSortName: 'call_time',
            defaultSortOrder: 'desc'
        }

        this._isMounted = false;

        this.onHideDispatchModal = this.onHideDispatchModal.bind(this);
        this.onShowDispatchModal = this.onShowDispatchModal.bind(this);
    }

    componentDidMount(){
        this._isMounted = true;
    }

    componentWillMount(){
        this.fetchAssignments();
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    render(){
        return (
                <div>
                    <Row className="widget-top-container">
                      <Col md={5} style={{backgroundColor: "white"}}>
                        <EventWidget events={this.props.events}/>
                      </Col>
                    </Row>
                    <Row className="main-settings-content">
                        <Col>
                            <div className="settings-header">
                                <h2 className="header-title left-header">Assignments</h2>
                                <div className="assignment-header-controls">
                                    <h5 className="on-duty-text">On Duty?</h5>
                                    <Switch
                                        onText = "YES"
                                        offText = "NO"
                                        value = {this.state.on_duty}
                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                        name='on_duty_toggle'
                                        id = "assignments-on-duty-toggle"
                                    />
                                    <input  onChange={e => this.table.handleSearch(e.target.value)} id="assignments-search-field" type="text" className="form-control" placeholder="Search Assignments..."/>
                                </div>
                            </div>
                            <div className="content-container">
                                {this.renderAssignments()}
                            </div>
                        </Col>
                    </Row>
                    {this.renderPreviewModal()}
                    {this.renderDispatchModal()}
                    <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                </div>
            )
    }

    renderAssignments(){
        const edit_options = {
            mode:'click',
            blurToSave:true,
            beforeSaveCell:this.onChangeDispatchTableValue
        }

        return(
            <div className="assignments-div">
                <BootstrapTable
                    ref={(component) => { this.table = component }}
                    width="100%" 
                    data={ this.tableData.rows } 
                    hover={true} 
                    keyField="id" 
                    search={false} 
                    pagination 
                    options={this.options} 
                    trClassName={"usersRow"}
                    cellEdit={ edit_options }
                >
                    <TableHeaderColumn editable={false} dataField='dispatch_number' width="15%" dataSort>Dispatch Number</TableHeaderColumn>
                    <TableHeaderColumn editable={false} dataField='date' width="10%" dataSort>Date</TableHeaderColumn>
                    <TableHeaderColumn editable={false} dataField='dispatch_time' width="15%" dataSort>Dispatch Time</TableHeaderColumn>
                    <TableHeaderColumn editable={false} dataField='call_time' width="15%" dataSort>Call Time</TableHeaderColumn>
                    <TableHeaderColumn editable={false} dataField='location_name' width="10%" dataSort>Location</TableHeaderColumn>
                    <TableHeaderColumn
                        dataField='status'
                        width="10%"
                        dataSort
                        editable={{
                            type: 'select',
                            options:{
                                values: ['In Progress','Completed']
                            }
                        }}
                        //dataFormat={this.renderDispatchStatus}
                    >
                        Status
                    </TableHeaderColumn>
                    <TableHeaderColumn editable={false} dataField='priority' width="10%" dataSort>Priority</TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

    /*renderDispatchStatus = (cell, row) => {
        const {status} = row;
        return status;
        const {status} = row;
        const finalStatus = status ? status : "In Progress";
        const className = finalStatus == "In Progress" ? "dispatch-progress-label" : "dispatch-completed-label";
        return (
          <span className={className}> {finalStatus}</span>
        );
    }*/


    onChangeDispatchTableValue = (row,name,value) =>{
        if(name === 'status'){
            const {dispatch_id} = row;
            const param = {
                dispatch_id,
                status:value
            };

            AssignmentService.sharedInstance.updateDispatchStatus(param)
                .then(res => {
                    
                }).catch(err => {
                    console.error('Error',err);
                });
        }
    }

    renderPreviewModal(){
        return(
            <Modal show={this.state.showInfoModal}>
                <Modal.Header>
                    <b style={{fontSize: 20}}>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={
                                <Tooltip id="overlay-example"> Close </Tooltip>
                        }>
                        <Glyphicon
                            glyph="remove"
                            className="pull-right"
                            style={{cursor: "pointer", marginLeft: 10}}
                            onClick={()=>{
                                this.setState({showInfoModal: false});
                            }}
                        />
                    </OverlayTrigger>
                    </b>
                </Modal.Header>
                <Modal.Body>
                    { this.renderHeaderSection() }
                    { this.renderFormSection() }
                </Modal.Body>
            </Modal>
        )
    }

    onShowDispatchModal = () =>{
        this.setState({
            dispatch_modal:true
        });
    }

    onHideDispatchModal = () =>{
        this.setState({
            dispatch_modal:false
        });
    }

    renderDispatchModal = () =>{
        const {dispatch_modal,assignmentToDisplay} = this.state;
        const dispatch = assignmentToDisplay;

        if(dispatch){
            const {dispatch_number,personnel_data,date_added,forms_data,external_agency_data} = dispatch;

            const external_agency = UtilsService.sharedInstance.tryParseJSON(external_agency_data) ? JSON.parse(external_agency_data) : {};
            const personnels = UtilsService.sharedInstance.tryParseJSON(personnel_data) ? JSON.parse(personnel_data) : [];
            const forms = UtilsService.sharedInstance.tryParseJSON(forms_data) ? JSON.parse(forms_data) : [];

            const date = date_added ? moment(date_added,'YYYY-MM-DD HH:mm:ss A') : false;

            return (
                <Modal
                    size='lg'
                    show={dispatch_modal} 
                    onHide={this.onHideDispatchModal}
                    dialogClassName='dispatch-modal modal-lg'
                >
                    <Modal.Header>
                        <OverlayTrigger
                            placement='top'
                            delay={200}
                            overlay={<Tooltip id='close-dispatch-tip'> Close </Tooltip>}
                        >
                            <Glyphicon
                                glyph='remove'
                                className='pull-right'
                                style={{cursor:'pointer',marginLeft:10}}
                                onClick={this.onHideDispatchModal}
                            />
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={3} mdOffset={6}>
                                <div className='incident-dispatch-block'>
                                    <h5 className='incident-card-text'>Date</h5>
                                    <h5 className='dispatch-date-value'>{date ? date.format('MMMM DD, YYYY hh:mm A') : ''}</h5>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className='incident-dispatch-block'>
                                    <h5 className='incident-card-text'>Dispatch No.</h5>
                                    <h5 className='dispatch-date-value'>{dispatch_number}</h5>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <h3 className='sub-title'>Dispatch Information</h3>
                                <hr className='line' />

                                <div>
                                    <h5 className='info-type'>Call Type</h5>
                                    <h5 className='box-info-data'>{dispatch.call_type}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Facility</h5>
                                    <h5 className='box-info-data'>{dispatch.facility}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Location</h5>
                                    <h5 className='box-info-data'>{dispatch.location_name}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Detailed Location Description</h5>
                                    <h5 className='box-info-data'>{dispatch.location_description}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Incident Narrative</h5>
                                    <h5 className='box-info-data'>{dispatch.incident_narrative}</h5>
                                </div>
                            </Col>
                            <Col md={6}>
                                <h3 className='sub-title'>Dispatch Personnel Details</h3>
                                <hr className='line' />

                                {
                                    personnels.map((value,key) => {
                                        const name = value.name || '';
                                        const time_dispatch = value.time_dispatch || '';
                                        const time_arrived = value.time_arrived || '';
                                        const guard_status = value.guard_status || '';

                                        return (
                                            <React.Fragment key={key}>
                                                <Row>
                                                    <Col md={12}>
                                                        <h5 className='info-type'>Dispatch Personnel</h5>
                                                        <h5 className='box-info-data'>{name}</h5>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={4}>
                                                        <h5 className='info-type'>Dispatch Time</h5>
                                                        <h5 className='box-info-data'>{time_dispatch}</h5>
                                                    </Col>
                                                    <Col md={4}>
                                                        <h5 className='info-type'>Arrival Time</h5>
                                                        <h5 className='box-info-data'>{time_arrived}</h5>
                                                    </Col>
                                                    <Col md={4}>
                                                        <h5 className='info-type'>Guard Status</h5>
                                                        <h5 className='box-info-data'>{guard_status}</h5>
                                                    </Col>
                                                </Row>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <h3 className='sub-title'>External Agency</h3>
                                <hr className='line' />

                                {
                                    Object.keys(external_agency).map((value,key) => {
                                        const agency = external_agency[value];
                                        const time_dispatch = agency.time_dispatch || '';
                                        const time_arrived = agency.time_arrived || '';
                                        const time_cleared = agency.time_cleared || '';
                                        const notes = agency.notes || '';

                                        if(agency){
                                            const name = value.replace(/_/g,' ').toUpperCase();

                                            return (
                                                <React.Fragment key={key}>
                                                    <div>
                                                        <h5 className='info-type'>{name}</h5>
                                                    </div>

                                                    <Row>
                                                        <Col md={4}>
                                                            <h5 className='info-type'>Time Dispatch</h5>
                                                            <h5 className='box-info-data'>{time_dispatch}</h5>
                                                        </Col>
                                                        <Col md={4}>
                                                            <h5 className='info-type'>Time Arrived</h5>
                                                            <h5 className='box-info-data'>{time_arrived}</h5>
                                                        </Col>
                                                        <Col md={4}>
                                                            <h5 className='info-type'>Time Cleared</h5>
                                                            <h5 className='box-info-data'>{time_cleared}</h5>
                                                        </Col>
                                                    </Row>

                                                    <div>
                                                        <h5 className='info-type'>Notes</h5>
                                                        <h5 className='box-info-data'>{notes}</h5>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }

                                        return null;
                                    })
                                }
                            </Col>
                            <Col md={6}>
                                <h3 className='sub-title'>Report Personnel Details</h3>
                                <hr className='line' />

                                <div>
                                    <h5 className='info-type'>Personnel Reporting This Incident</h5>
                                    <h5 className='box-info-data'>{dispatch.personnel_name || ''}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Personnel Phone</h5>
                                    <h5 className='box-info-data'>{dispatch.personnel_phone || ''}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Location of Personnel</h5>
                                    <h5 className='box-info-data'>{dispatch.personnel_location || ''}</h5>
                                </div>

                                <div>
                                    <h5 className='info-type'>Notes</h5>
                                    <h5 className='box-info-data'>{dispatch.personnel_additional_notes || ''}</h5>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <h3 className='sub-title'>Form</h3>
                                <hr className='line' />

                                {
                                    forms.map((value,key) => {
                                        return (
                                            <div key={key}>
                                                <h5 className='box-info-data'>{value.form_name}</h5>
                                            </div>
                                        )
                                    })
                                }
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='red-btn btn btn-default' onClick={this.onHideDispatchModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
            )
        }

        return null;
    }

    renderHeaderSection(){

        if (this.state.assignmentToDisplay == null) {
            return null;
        }

        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }

        // var month = months[this.state.date_added.getMonth()];
        // var date = month + " " + this.state.date_added.getDate() + ", " + this.state.date_added.getFullYear();
        // var time = this.state.date_added.formattedTime();

        var date = this.state.assignmentToDisplay.date;
        var time = this.state.assignmentToDisplay.call_time;
        var dispatch_no = this.state.assignmentToDisplay.dispatch_number;

        var title = this.state.assignmentToDisplay.title;

        return(
            <div className="incident-header">
                <div className="incident-title">
                    <h1 className="orange-title left">{title}</h1>
                </div>
                <div className="incident-dispatch-info">
                    <div className="incident-dispatch-block">
                        <h5 className="incident-card-text">Dispatch No.</h5>
                        <h5 className="dispatch-date-value">{dispatch_no}</h5>
                    </div>

                    <div className="incident-date-block">
                        <h5 className="incident-card-text">Date</h5>
                        {/* <Button className="incident-edit-button">Edit</Button> */}
                        <h5 className="dispatch-date-value">{date}</h5>
                        <h5 className="dispatch-date-value">@ {time}</h5>
                    </div>
                </div>
            </div>
        )
    }

    renderFormSection(){
        if (this.state.assignmentToDisplay == null) {
            return null;
        }

        let dispatch = this.state.assignmentToDisplay;

        return(
            <div className="incident-section">
                <div className="left-side-content">

                    <h3 className="sub-title">Dispatch Information</h3>
                    <hr className="line"/>

                    <h5 className="info-type">Call Type: </h5>
                    <h5 className="box-info-data">{dispatch.call_type}</h5>

                    <h5 className="info-type">Facility: </h5>
                    <h5 className="box-info-data">{dispatch.facility}</h5>

                    <h5 className="info-type">Detailed Location Description:</h5>
                    <p className="box-info-data">{dispatch.location_description}</p>

                    <h5 className="info-type">Incident Narrative:</h5>
                    <p className="box-info-data">{dispatch.incident_narrative}</p>
                </div>

                <div className="right-side-content">

                    <h3 className="sub-title">Reporting Person Details</h3>
                    <hr className="line"/>

                    <h5 className="info-type">Personnel Reporting This Incident: </h5>
                    <h5 className="box-info-data">{dispatch.personnel_name}</h5>

                    <h5 className="info-type">Personnel Phone: </h5>
                    <h5 className="box-info-data">{dispatch.personnel_phone}</h5>

                    <h5 className="info-type">Location of Personnel:</h5>
                    <h5 className="box-info-data">{dispatch.personnel_additional_notes}</h5>

                    <button className="btn btn-primary" style={{marginTop: 20, float: "right"}} onClick={this.onShowDispatchModal}>
                        Access Dispatch
                    </button>
                </div>
            </div>
        )
    }

    fetchAssignments(){
        AssignmentService.sharedInstance.getAllByPersonnelId()
        .then((response)=>{
            
            response.map((item)=>{
                const other_form_data = UtilsService.sharedInstance.tryParseJSON(item.other_form_data) ? JSON.parse(item.other_form_data) : {};
                const callType = item.call_type ? item.call_type : "";
                const locationName = item.location_name ? item.location_name : "";
                const dispatchTitle = callType + " Incident at " + locationName;

                const item_data = {
                    "id": item.id,
                    "title": dispatchTitle,
                    'dispatch_id':item.dispatch_id,
                    "dispatch_number": "#" + item.dispatch_number,
                    "date": item.date_added != "0000-00-00 00:00:00" ? moment(item.date_added).format("MM/DD/YYYY") : "",
                    "dispatch_time": item.dispatched_time != "0000-00-00 00:00:00" ? moment(item.dispatched_time).format("hh:mm A") : "",
                    "call_time": item.date_added != "0000-00-00 00:00:00" ? moment(item.date_added).format("hh:mm A") : "",
                    "location_name": item.location_name,
                    "status": item.status,
                    "priority": "",
                    "facility":item.facility_name,
                    "location_description": item.location_description,
                    "incident_narrative": item.incident_narrative,
                    "personnel_name": other_form_data.personnel_name ,
                    "personnel_phone":  other_form_data.personnel_phone ,
                    "personnel_additional_notes": other_form_data.additional_notes,
                    "incident_type": item.incident_type,
                    "call_type": item.call_type,
                    'forms_data':item.forms_data,
                    'status':item.status,
                    'other_form_data':other_form_data,
                    'external_agency_data':item.external_agency_data || null,
                    'personnel_data':item.personnel_data || null,
                    'date_added':item.date_added
                }


                this.tableData.rows.push(item_data);
            })

            this.setState({data: this.tableData});
        })
    }

    openModal(row){
        this.setState({showInfoModal: true, assignmentToDisplay: row});
    }

    handleSwitch(elem, state) {
        this.setState({on_duty: state});
        AssignmentService.sharedInstance.setOnDutyStatus(state)
        .then((response)=>{
            localStorage.setItem("onDuty", state == true ? 1 : 0);
        });
    }
}

export default Assignments;
